<script>
  import download from "downloadjs";
  import Header from "lib/components/Header.svelte";
  import ButtonChevron from "../../../../lib/components/ButtonChevron.svelte";
  import AnonymizationList from "../../damprojects-frontend/components/AnonymizationList.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import RuleDataTable from "../components/RuleDataTable.svelte";
  import PreprocessingHeaderButtons from "./PreprocessingHeaderButtons.svelte";
  import { Button } from "paxray-components-svelte";

  export let idproject;

  let modalOpen = false;
  let anonymizationsupdated = false;
  let currentAnonymizationRule = {
    id: null,
    name: "",
    applicationname: "",
    search: "",
    replace: "",
    step: 0,
  };

  let seeTable = true;
  let idAnonymization = null;

  $: console.log("idproject", idproject);

  $: if (idproject) {
    fetchWithSession(`/api/damprojects/getProjectAnonymizations/${idproject}/2`)
      .then((res) => res.json())
      .then((data) => {
        idAnonymization = data;
      });
  }

  function exportPreprocessingSteps() {
    fetchWithSession(
      `/api/damprojects/exportDAMAnonymizationRule/` + idAnonymization,
    )
      .then((response) => response.blob())
      .then((data) => {
        download(data, "preprocessing.csv", "text/plain");
      });
  }
  function downloadAppOverviewAll() {
    fetchWithSession(`/api/analysis/getAppOverviewAll`)
      .then((response) => response.blob())
      .then((data) => {
        download(
          data,
          "allAppsPerTeam.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        );
      });
  }
  function importPreprocessingSteps() {
    let fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".csv";
    fileInput.onchange = function () {
      let file = fileInput.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let content = e.target.result;
        importPreprocessingStepsContent(content);
      };
      reader.readAsText(file);
    };
    fileInput.click();
  }
  function importPreprocessingStepsContent(content) {
    fetchWithSession(
      `/api/damprojects/importDAMAnonymizationRule/${idAnonymization}`,
      {
        method: "POST",
        body: JSON.stringify({
          file: content,
          idproject: idproject,
          projectStep: 2,
        }),
      },
    )
      .then((response) => response.text())
      .then((data) => {
        anonymizationsupdated = true;
      });
  }

  function handleMarkAsCompleted() {
    console.log("Marking as completed...");
  }
</script>

<Header section="Preprocessing" breadcrumb="Applications">
  <Button
    kind="secondary"
    text={`Mark as Completed`}
    on:click={handleMarkAsCompleted}
  />
  <PreprocessingHeaderButtons
    {idproject}
    {exportPreprocessingSteps}
    {importPreprocessingSteps}
    {downloadAppOverviewAll}
  ></PreprocessingHeaderButtons>
</Header>

<div class="main">
  <div class="table_wrapper">
    <div class="table_heading bold">Data</div>
    <RuleDataTable bind:currentAnonymizationRule bind:modalOpen></RuleDataTable>
  </div>
  <div class="table_wrapper">
    <div class="table_heading bold">
      <span>Rules</span>
      <ButtonChevron bind:seeElement={seeTable} />
    </div>
    {#if seeTable}
      <AnonymizationList
        {idAnonymization}
        editable={true}
        bind:currentAnonymizationRule
        bind:anonymizationRuleModalOpen={modalOpen}
        bind:updated={anonymizationsupdated}
      />
    {/if}
  </div>
</div>

<style>
  .main {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
    max-width: 100%;
  }

  .table_wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
  }

  .table_heading {
    padding-bottom: 1rem;
    display: flex;
    gap: 1rem;
    align-items: center;
  }
</style>
